import React, { memo } from 'react';
import { css } from 'styled-components';
import { ContentContainer, Description, MetaData, Title, extendedLinkStylesWithTitle } from './MediaTeaserParts.styles';
import { MediaTeaserWrapper } from './MediaTeaserWrapper';
import { useMediaInformation } from './use-media-information';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { gridTeaserImageWidth, smallGridTeaserImageWidth, xLargeGridTeaserImageWidth } from '../../Image/image-width';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GridMediaTeaser = /*#__PURE__*/memo(({
  media,
  ariaLabel,
  labelOrder,
  index,
  ...rest
}) => {
  const {
    title,
    meta,
    description
  } = useMediaInformation(media);
  return /*#__PURE__*/_jsx(MediaTeaserWrapper, {
    media: media,
    index: index,
    labelOrder: labelOrder,
    linkStyles: extendedLinkStylesWithTitle,
    ariaLabel: ariaLabel,
    horizontalOnMobile: true,
    horizontalContainerStyles: horizontalContainerStyles,
    imageWidth: gridTeaserImageWidth,
    smallImageWidth: smallGridTeaserImageWidth,
    xLargeImageWidth: xLargeGridTeaserImageWidth,
    ...rest,
    children: /*#__PURE__*/_jsxs(ContentContainer, {
      children: [meta.length > 0 && /*#__PURE__*/_jsx(MetaData, {
        "aria-hidden": "true",
        children: meta
      }), /*#__PURE__*/_jsx(Title, {
        "aria-hidden": "true",
        children: title
      }), /*#__PURE__*/_jsx(Description, {
        children: description
      })]
    })
  });
});
export const horizontalContainerStyles = css(["", "{display:flex;flex-direction:column-reverse;justify-content:flex-end;}"], Viewports.for('small'));